<form nz-form [formGroup]="claimReportSearchForm">
    <div nz-row>
        <div nz-col [nzXs]="24" [nzSm]="8" [nzMd]="6">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a field name'">
                    <input placeholder="Field Name" nz-input formControlName="fieldName" id="fieldName" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8"
            style="text-align: right; margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <ppl-button label="Search" type="submit" icon="fa fa-search" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (handleClick)="search()"></ppl-button>
            </nz-form-item>
        </div>
    </div>
    @if(errorMsg){
    <div style="color: red; margin-bottom: 16px;">
        {{errorMsg}}
    </div>
    }
</form>
<ppl-list-table [disableSearch]="true" [cols]="claimCols" [showCustomSearch]="false" [enableActions]="false"
    [data]="claimReportData" [disableSelection]="true" [gridTitle]="false" [disableSort]="true" [pagination]="true"
    [loadPage]="false" [from]="'billing'" [customDataLoaded]="true">
</ppl-list-table>